import React, { useEffect, useState } from 'react';
import styles from '../../Form/Editor/Quill/Basic/styles.module.scss';
import './style.css';
import Quill from 'quill';

// need @tailwindcss/typography for prose

const QuillMadeArticle = ({ contents, customStyles = {} }) => {
    const [contentsHtml, setContentsHtml] = useState("");
    const [virtualQuill] = useState(new Quill(document.createElement('div')));

    useEffect(() => {
        virtualQuill.setContents(contents);
        setContentsHtml(virtualQuill.getSemanticHTML());
    }, [contents])

    return (
        <article
            className={`prose prose-sm prose-p:my-1 prose-p:min-h-4 prose-ul:my-0 min-w-full ${styles.customSize}`}
            style={customStyles}
        >
            <div dangerouslySetInnerHTML={{ __html: contentsHtml }} />
        </article>
    )
}

export default QuillMadeArticle;
